<template>
	<div>
		<a
			href="#"
			class="nk-button nk-button-gray nk-button-desktop"
			v-if="providers.available.length && activities.selected"
			@click.prevent="toggleSelectingProvider"
			:class="{
				'link-plus-right': !ui.selectingProvider,
				'link-close-right': ui.selectingProvider || providers.selected,
			}"
		>
			<span
				v-if="providers.selected"
				v-html="formatProviderNameInList(providers.selected)"
				class="inner-text"
			></span>
			<span v-if="!providers.selected">Behandlare</span>
		</a>
		<a
			href="#"
			class="nk-button nk-button-gray nk-button-inactive"
			@click.prevent=""
			v-if="!providers.available.length && activities.selected"
			>Behandlare
			<img
				class="loading-spinner"
				src="/wp-content/themes/nordiskakliniken/dist/images/loading-spinner.svg"
			/>
		</a>
	</div>
</template>
<script>
import { mapState, mapGetters, mapActions } from "vuex";

export default {
	components: {},
	computed: {
		...mapState(["ui", "providers", "activityGroups", "activities"]),
		...mapGetters([]),
	},
	methods: {
		...mapActions(["toggleSelectingProvider"]),
		formatProviderNameInList(name) {
			return this.$store.getters.formatProviderNameInList(name);
		},
	},
};
</script>